// extracted by mini-css-extract-plugin
export default {"CartMessage":"CartMessage_CartMessage__vwRyg"};